import React from 'react';
import { Grid, Row, Col, Carousel } from '../utils/bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Colors from '../Colors';
import MainImage from '../components/MainImage';

class ProductInfo extends React.Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Premium Funding | Premium Capital Partners</title>
          <meta name="description" content="Our pioneering Premium Funding product offers an innovative financing solution for the payment of annual insurance premiums for business." />
        </Helmet>
        <Carousel indicators={false}>
          <Carousel.Item>
            <MainImage img="/premium.jpg" containerStyle={{ backgroundPosition: 'center bottom' }}>
              <h1>Insurance premium funding</h1>
              <div />
              <h2>Premium Financing</h2>
              <div />
            </MainImage>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/property.jpg"
                       containerStyle={{ backgroundPosition: 'center bottom' }} />
            <Carousel.Caption>
              <h3>
                Financing for Property & Casualty Insurance Policies
              </h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/hotel.jpg" />
            <Carousel.Caption>
              <h3>
                Financing for Public Liability/Third Party Insurance Policies
              </h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/rig.jpg" />
            <Carousel.Caption>
              <h3>
                Financing for Financial & Political Risk Insurance Policies
              </h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/gear.jpg" />
            <Carousel.Caption>
              <h3>
                Financing for Industrial All Risk Insurance Policies
              </h3>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <MainImage img="/professional.jpg" />
            <Carousel.Caption>
              <h3>
                Financing for Professional Liability & Executive Risk Policies
                and many others
              </h3>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        <Grid>
          <Row>
            <Col md={7} xs={12}>
              <p>
                Our pioneering Premium Financing product is the first of its kind in Malaysia,
                offering access to insurance premium funding that helps ensure organisations can
                meet the costs of cover for critical business insurance.
              </p>
              <p>
                Annual insurance costs constitute a significant capital expenditure for any
                business. Not only can these lump sum payments create challenges for operational
                cash flow, the financial burden raises the potential for increased risk through
                under-insured assets, missed payments and lost cover. Premium Capital Partners'
                unique insurance financing solution offers a flexible payment policy that enables
                customers to reduce their exposure to this risk through managed monthly payments.
              </p>
            </Col>
            <Col md={5} xs={12}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '0 5rem'
              }}>
                <img src="/quot-white.png"
                     style={{ margin: 'auto', width: 90, height: 'auto' }}
                     alt="" />
                <h3 style={{
                  fontSize: '1.3em',
                  color: 'white',
                  textAlign: 'center'
                }}>
                  Insurance is the equitable transfer of the risk of loss from one entity to another
                  in
                  exchange for payment. And what we do is finance that payment
                </h3>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <h4>
                How does premium financing work?
              </h4>
              <p>
                Premium financing operates through a simple agreement between the Policy
                Holder, Premium Capital Partners, and relevant Insurance Company. It offers
                an innovative business funding solution for any annual and cancellable
                insurance policy.
              </p>
              <p>
                Our Premium Financing provides an annual loan on fixed rate interest for
                insurance policies with premiums of RM100,000 and above. This loan is
                supported by an agreement made by the Policy Holder to repay this credit in
                monthly payments over a period no longer than 10 months. We offer credit up
                to 80% of the value of an annual insurance cover, with 20% covered by the
                Policy Holder. No additional asset or collateral is required against the
                value of this loan, and no Personal Guarantee from a named individual is
                needed.
              </p>
              <p>
                We can revert with an offer within 3 working days of application if all the terms
                and
                conditions are met, meaning rapid approval for business-critical insurance.
              </p>
              <Row className="premium-icons">
                <Col xs={6} md={3}>
                  <img alt="" src="/svg-icons/give-money.svg" />
                  <p>Cover for policy costs of{'\n'}<span className="bold">RM100,000</span> and above</p>
                </Col>
                <Col xs={6} md={3}>
                  <img alt="" src="/svg-icons/arrow.svg" />
                  <p><span className="bold">NO</span> single{'\n'} customer limit</p>
                </Col>
                <Col xs={6} md={3}>
                  <img alt="" src="/svg-icons/protection.svg" />
                  <p>Up to <span className="bold">80%</span> margin {'\n'}of finance</p>
                </Col>
                <Col xs={6} md={3}>
                  <img alt="" src="/svg-icons/calendar.svg" />
                  <p>Up to <span className="bold">10-month</span>{'\n'}repayment period</p>
                </Col>
                <Col xs={6}  md={3}>
                  <img alt="" src="/svg-icons/like.svg" />
                  <p><span className="bold">NO</span> additional{'\n'}collateral required</p>
                </Col>
                <Col xs={6}  md={3}>
                  <img alt="" src="/svg-icons/hand-shake.svg" />
                  <p><span className="bold">NO</span> Personal Guarantee or Directors Guarantee</p>
                </Col>
                <Col xs={6}  md={3}>
                  <img alt="" src="/svg-icons/document.svg" />
                  <p><span className="bold">Standard</span>{'\n'}documentation</p>
                </Col>
                <Col xs={6}  md={3}>
                  <img alt="" src="/svg-icons/fast-delivery.svg" />
                  <p>Approval within{'\n'}<span className="bold">3 working days</span></p>
                </Col>
              </Row>
              <ul>
                <li>
                </li>
                <li></li>
                <li></li>
              </ul>
              <p style={{ fontStyle: 'italic' }}>
                Note: Premium Financing is currently only available for selective insurance
                providers.
              </p>
            </Col>
          </Row>
          <Row className="lined-row">
            <Col lg={4}>
              <h4>
                How do businesses benefit from insurance premium financing?
              </h4>
            </Col>
            <Col lg={8}>
              <p>
                By removing the burden of a single annual payment upfront, our Premium Financing
                facilitates the affordability of insurance for businesses. This financing
                not only unlocks operational capital to generate greater value elsewhere for
                a business, but helps maintain the affordability of insurance cover while
                reducing financial exposure to under-insured assets.
              </p>
            </Col>
          </Row>
          <Row className="lined-row">
            <Col lg={4}>
              <h4>
                How does premium financing help insurance companies?
              </h4>
            </Col>
            <Col lg={8}>
              <p>
                Insurance companies are increasingly looking for innovative ways to facilitate
                appropriate cover for their customers. By offering an insurance premium financing
                model that makes the cost of cover more affordable, Premium Financing limits the
                exposure of individual businesses to insurance risks. This helps mitigate overall
                market risk while reducing the exposure of insurance companies to the financial
                challenges of missed or late premium payments.
              </p>
            </Col>
          </Row>
          <Row className="lined-row">
            <Col lg={4}>
              <h4>
                What benefits does Premium Financing offer insurance brokers?
              </h4>
            </Col>
            <Col lg={8}>
              <p>
                Insurance premium funding offers the opportunity to generate more business by
                providing an additional solution which you can present to your clients. Not only
                does
                this innovative product offer cover for clients who may wish to have a payment
                option, the settlement of premium via Premium Funding would result in the receipt
                of commission on a timely basis.
              </p>
            </Col>
          </Row>
          <Row className="lined-row">
            <Col lg={4}>
              <h4>
                How trusted is the premium financing market?
              </h4>
            </Col>
            <Col lg={8}>
              <p>
                While Premium Capital Partners are the pioneers of this model of financing in
                Malaysia, the market for premium funding around the world is relatively mature.
                Premium financing emerged in the 1950s, and is today a common form of insurance
                financing
                offered in countries such as the United States, Australia and the United Kingdom.
                The global market size is estimated at around US$55 billion, representing a
                substantial insurance market that has demonstrated a strong positive performance
                with very limited credit losses to date.
              </p>
              <p>
                Premium Capital Partners is excited take on this opportunity to present the benefits
                of this
                innovative product that helps to reduce risk and unlock business opportunities for
                Malaysian businesses.
              </p>
            </Col>
          </Row>
        </Grid>
        <div style={{ backgroundColor: Colors.grey, width: '100%' }}>
          <Grid>
            <Row style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Col xs={12} sm={9}>
                <h4
                  style={{ color: 'white', fontWeight: 'normal', fontSize: '1.2em', marginTop: 0 }}>
                  If you want to explore more about our Premium Financing product, and how
                  insurance premium financing can work for your business, consult your insurance
                  broker or get in touch with Premium Capital Partners.
                </h4>
              </Col>
              <Col xs={12} sm={3} className="contact-button">
                <Link to="/contact-us">
                  <button style={{ borderColor: Colors.lightBlue, color: Colors.lightBlue }}>
                    Contact Us
                  </button>
                </Link>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/screens/Premium.js